const requestStatus = {
  initial: 'not loaded',
  pending: 'loading',
  fulfilled: 'loaded',
  error: 'error',
};

export default requestStatus;
